module.exports = __webpack_public_path__ + "img/柔性生产，小单快反ico.9286ed6f.png";